import { useContext } from 'react';

import AuthContext, { UserAuthContext } from '../contexts/AuthProvider';

function useAuth(): UserAuthContext {
  return useContext(AuthContext);
}

export default useAuth;
